import { InputWithLabelWrapper, TicketInfoLabel } from "../TicketInfoField/TicketInfoField.styled";
import { useId } from "react";
import { StatusBadgeProps } from "../../../../../common/StatusBadge/StatusBadge.types";
import { StatusBadge } from "../../../../../common/StatusBadge/StatusBadge";


export const StatusField = ({status}: StatusBadgeProps) => {

    const [inputId] = useId();
    return (
        <InputWithLabelWrapper >
            <TicketInfoLabel htmlFor={inputId} size="medium">Status</TicketInfoLabel>
            <StatusBadge status={status} />
        </InputWithLabelWrapper>
    );
}